/**
 * Which dashboard tiles feed a section infographic, and how a tile's number is read.
 * Only tiles the server reports as available (no `availability` other than 'available') with a
 * numeric value are charted; anything else stays a normal tile so its "why not available" copy shows.
 */
import { isNum } from '../components/charts/chartUtils';

export function tileNumber(tile) {
  if (!tile) return null;
  if (tile.availability && tile.availability !== 'available') return null;
  const v = tile.value;
  if (isNum(v)) return v;
  if (v && typeof v === 'object') {
    if (isNum(v.percent)) return v.percent;
    if (isNum(v.count)) return v.count;
  }
  return null;
}

// Section keys (utils/dashboardLayout.js) whose tiles are drawn as one infographic card.
export const INFOGRAPHIC_SECTIONS = {
  delivery: 'delivery',
  progress: 'delivery',
  evidence: 'evidence',
  team: 'team',
};

const IDS = {
  delivery: ['gap.readiness_percent', 'gap.controls_in_scope', 'control.implemented_count', 'control.in_review_count', 'control.approved_this_month'],
  evidence: ['evidence.documents_count', 'evidence.documents_scored', 'evidence.incident_count'],
  team: ['gap.delegates_responsive', 'gap.advisors_engaged'],
};

/** Tiles of the section that the infographic can chart, keyed by tileId. Empty map = no card. */
export function chartableTiles(sectionKey, tiles) {
  const kind = INFOGRAPHIC_SECTIONS[sectionKey];
  const out = new Map();
  if (!kind) return out;
  (tiles || []).forEach((t) => {
    if (IDS[kind].includes(t.tileId) && tileNumber(t) != null) out.set(t.tileId, t);
  });
  return out;
}

/** Latest computedAt (ISO string) among tiles, or null. */
export function latestComputedAt(tiles) {
  const times = tiles.map((t) => t.computedAt).filter(Boolean).map((s) => [Date.parse(s), s]).filter(([n]) => Number.isFinite(n));
  if (!times.length) return null;
  return times.sort((a, b) => b[0] - a[0])[0][1];
}
